/* eslint-disable */

import React, { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { Button } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import Swal from "sweetalert2";
import { Badge } from "@mui/material";
import GoPurchase from "../PurchaseFormReOrder/AddPurchase";

import StockCountModal from "../../StockCountModal";

import { Link } from "react-router-dom";
import {
  FaCashRegister,
  FaFileMedical,
  FaPenSquare,
  FaRegEdit,
  FaRegTrashAlt,
  FaFileExport,
  FaAngleDoubleRight,
} from "react-icons/fa";

import { useSelector } from "react-redux";
import { format } from "date-fns-tz";
import BASE_API_URL from "../../../../api/api";
import apiInstance from "../../../../Utils/api";
export default function Stock() {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  const api = apiInstance;

  const [searchProResults, setSearchProResults] = useState([]);
  const [showProSearch, setShowProSearch] = useState(false);
  const [hidePro, setHidePro] = useState(true);
  const [proName, setProName] = useState("");
  const [open, setOpen] = useState(false);

  const [searchMedResults, setSearchMedResults] = useState([]);
  const [showMedSearch, setShowMedSearch] = useState(false);
  const [showGenSearch, setShowGenSearch] = useState(false);
  const [hideGen, setHideGen] = useState(true);
  const [hideMed, setHideMed] = useState(true);
  const [medName, setMedName] = useState("");

  const [searchProAccResults, setSearchProAccResults] = useState([]);
  const [showProAccSearch, setShowProAccSearch] = useState(false);
  const [hideProAcc, setHideProAcc] = useState(true);
  const [proAccName, setProAccName] = useState("");

  const [relatedProBranch, setRelatedProBranch] = useState([]);
  const [showBranch, setShowBranch] = useState(false);
  const [showProBranch, setShowProBranch] = useState(false);
  const [showProAccBranch, setShowProAccBranch] = useState(false);
  const [showOrigin, setShowOrigin] = useState(true);
  const [showGenBranch, setShowGenBranch] = useState(false);

  const [proUnitLists, setProUnitLists] = useState([]);
  const [medUnitLists, setMedUnitLists] = useState([]);
  const [porAssLists, setProAssLists] = useState([]);
  // const [showMedicine, setShowMedicine] = useState(true)
  const [showProUnit, setShowProUnit] = useState(false);
  const [showProAss, setShowProAss] = useState(false);

  const [branchesLists, setBranchesLists] = useState([]);

  const [mQty, setMQty] = useState("");

  const [mTotal, setMTotal] = useState("");

  const [pmQty, setPMQty] = useState("");

  const [pmTotal, setPMTotal] = useState("");
  const [pmSell, setPMSell] = useState(0);
  const [pmPurchase, setPMPurchase] = useState(0);

  const [status, setStatus] = useState("UnCheck");

  const [paTotal, setPATotal] = useState("");
  const [paSell, setPASell] = useState(0);
  const [paPurchase, setPAPurchase] = useState(0);

  const [proId, setProId] = useState("");
  //Med
  const [medHoShow, setMedHoShow] = useState(true);
  // const [proName, setProName] = useState('')

  const ButtonStyle = { margin: "10px 10px" };
  const ErrorColor = { border: "red" };
  const [branchID, setBranchID] = useState("");
  const [accBranchCount, setAccBranchCount] = useState("");
  const [medBranchCount, setMedBranchCount] = useState("");
  const [proBranchCount, setProBranchCount] = useState("");
  const [genBranchCount, setGenBranchCount] = useState("");

  const [accBranchItemList, setAccBranchItemList] = useState([]);
  const [medBranchItemList, setMedBranchItemList] = useState([]);
  const [proBranchItemList, setProBranchItemList] = useState([]);
  const [genBranchItemList, setGenBranchItemList] = useState([]);

  //For Ho
  const [accHOCount, setAccHOCount] = useState("");
  const [medHOCount, setMedHOCount] = useState("");
  const [proHOCount, setProHOCount] = useState("");
  const [genHOCount, setGenHOCount] = useState("");

  const [accHOItemList, setAccHOItemList] = useState([]);
  const [medHOItemList, setMedHOItemList] = useState([]);
  const [proHOItemList, setProHOItemList] = useState([]);
  const [genHOItemList, setGenHOItemList] = useState([]);

  const [showMed, setShowMed] = useState(false);
  const [showPro, setShowPro] = useState(false);
  const [showProAcc, setShowProAcc] = useState(false);
  const [showGen, setShowGen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  //for CheckBox Med

  const [medHOCheckList, setMedHOCheckList] = useState([]);
  const [medID, setMedID] = useState([]);
  const [medHOArr, setMedHOArr] = useState([]);
  const [purchaseLists, setPurchaseLists] = useState([]);

  //for Checkbox Pro
  const [proHOCheckList, setProHOCheckList] = useState([]);
  const [proID, setProID] = useState([]);
  const [proHOArr, setProHOArr] = useState([]);
  // const [checked, setChecked] = useState(true)

  //for Checkbox Pro-Acc
  const [proAccHOCheckList, setProAccHOCheckList] = useState([]);
  const [proAccID, setProAccID] = useState([]);
  const [proAccHOArr, setProAccHOArr] = useState([]);
  // const [checked, setChecked] = useState(true)
  const [genHOCheckList, setGenHOCheckList] = useState([]);
  const [genID, setGenID] = useState([]);
  const [genHOArr, setGenHOArr] = useState([]);

  const [medCount, setMedCount] = useState("");
  const [proCount, setProCount] = useState("");
  const handleMedUnitChange = (Id) => {
    // setShowMedicine(false)
    setShowMed(true);
    setShowPro(false);
    setShowProAcc(false);
    setShowOrigin(true);
    setShowGen(false);

    if (Id) {
      setShowProUnit(false);
      setShowProAss(false);
      setHideMed(true);
      setShowBranch(true);
      setShowProBranch(false);
      setShowProAccBranch(false);
      setShowGenBranch(false);
      setShowOrigin(false);
    }
  };

  const handleProUnitChange = (Id) => {
    setShowMed(false);
    setShowPro(true);
    setShowProAcc(false);
    setShowOrigin(true);
    setShowGen(false);
    if (Id) {
      setShowProUnit(false);
      setShowProAss(false);
      setShowBranch(false);
      setShowGenBranch(false);
      setShowProBranch(true);
      setShowProAccBranch(false);
      setShowOrigin(false);
    }
  };

  const handleProAssUnitChange = (Id) => {
    setShowMed(false);
    setShowPro(false);
    setShowProAcc(true);
    setShowOrigin(true);
    setShowGen(false);
    if (Id) {
      setShowProUnit(false);
      setShowBranch(false);
      setHideProAcc(true);
      setShowGenBranch(false);
      setShowProBranch(false);
      setShowOrigin(false);

      setShowProAccBranch(true);
    }
  };

  const handleGenUnitChange = (Id) => {
    setShowMed(false);
    setShowPro(false);
    setShowProAcc(false);
    setShowOrigin(true);
    setShowGen(true);
    if (Id) {
      setShowProUnit(false);
      setShowBranch(false);
      setHideProAcc(true);
      setShowGenBranch(true);
      setShowProBranch(false);
      setShowOrigin(false);
      // setHideGen(true)
      setShowProAccBranch(true);
    }
  };

  const _export1 = React.useRef(null);
  const _export2 = React.useRef(null);
  const _export3 = React.useRef(null);
  const _export4 = React.useRef(null);

  const excelExport1 = () => {
    if (_export1.current !== null) {
      console.log(_export1.current.props.data, "excel");

      _export1.current.props.data.map(function (element, index) {
        element.code = element.code;
      });

      _export1.current.save();
    }
  };

  const excelExport2 = () => {
    if (_export2.current !== null) {
      console.log(_export2.current.props.data, "excel");
      if (_export2.current.props.data === { medUnitLists }) {
        _export2.current.props.data.map(function (element, index) {
          element.code = element.code;
        });
      }
      _export2.current.save();
    }
  };

  const excelExport3 = () => {
    if (_export3.current !== null) {
      console.log(_export3.current.props.data, "excel");
      _export3.current.props.data.map(function (element, index) {
        element.code = element.code;
      });
      _export3.current.save();
    }
  };

  const excelExport4 = () => {
    if (_export4.current !== null) {
      console.log(_export4.current.props.data, "excel");
      _export4.current.props.data.map(function (element, index) {
        element.code = element.code;
      });
      _export4.current.save();
    }
  };

  useEffect(() => {
    // const getProUnitLists = async () => {
    //   try {
    //     const res = await api.get('procedure-items?limit=30')
    //     setProUnitLists(res.data.list)
    //     console.log(res.data.list)
    //     console.log(setProUnitLists.reOrderQuantity)
    //     setProId(res.data.list._id)
    //   } catch (err) {
    //     alert(err.message)
    //   }
    // }

    // const getMedUnitLists = async () => {
    //   try {
    //     const res = await api.get('medicine-items?limit=30')
    //     setMedUnitLists(res.data.list)
    //   } catch (err) {
    //     alert(err.message)
    //   }
    // }

    const getBranches = async () => {
      try {
        const res = await api.get("branches");
        setBranchesLists(res.data.list);
        console.log(res.data.list, "branch");
      } catch (err) {
        alert(err.message);
      }
    };

    const getPurchaseLists = async () => {
      try {
        const res = await api.get(
          "purchase-requests",
          //'http://localhost:9000/api/treatments'
        );
        console.log(res.data.list, "list");
        setMedHOItemList(
          res.data.list
            .filter((el) => el.relatedApprove && el.medicineItems[0])
            .filter(
              (i) =>
                i.medicineItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }),
                )[0],
            ),
        );
        setProHOItemList(
          res.data.list
            .filter((el) => el.relatedApprove && el.procedureItems[0])
            .filter(
              (i) =>
                i.procedureItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }),
                )[0],
            ),
        );
        setAccHOItemList(
          res.data.list
            .filter((el) => el.relatedApprove && el.accessoryItems[0])
            .filter(
              (i) =>
                i.accessoryItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }),
                )[0],
            ),
        );
        setGenHOItemList(
          res.data.list
            .filter((el) => el.relatedApprove && el.generalItems[0])
            .filter(
              (i) =>
                i.generalItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }),
                )[0],
            ),
        );
        // console.log(
        //   res.data.list
        //     .filter((el) => el.relatedApprove && el.medicineItems[0])
        //     .filter(
        //       (i) =>
        //         i.medicineItems.filter(
        //           (e) =>
        //             new Date(e.alertDate).toLocaleDateString("en-US", {
        //               year: "numeric",
        //               month: "2-digit",
        //               day: "2-digit",
        //             }) ===
        //             new Date().toLocaleDateString("en-US", {
        //               year: "numeric",
        //               month: "2-digit",
        //               day: "2-digit",
        //             })
        //         )[0]
        //     ),
        //   "p a l"
        // );
        // console.log(
        //   new Date().toLocaleDateString("en-US", {
        //     year: "numeric",
        //     month: "2-digit",
        //     day: "2-digit",
        //   }),
        //   "date now"
        // );

        setMedHOCount(
          res.data.list
            .filter((el) => el.relatedApprove && el.medicineItems[0])
            .filter(
              (i) =>
                i.medicineItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }),
                )[0],
            ).length,
        );
        setProHOCount(
          res.data.list
            .filter((el) => el.relatedApprove && el.procedureItems[0])
            .filter(
              (i) =>
                i.procedureItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }),
                )[0],
            ).length,
        );
        setAccHOCount(
          res.data.list
            .filter((el) => el.relatedApprove && el.accessoryItems[0])
            .filter(
              (i) =>
                i.accessoryItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }),
                )[0],
            ).length,
        );
        setGenHOCount(
          res.data.list
            .filter((el) => el.relatedApprove && el.generalItems[0])
            .filter(
              (i) =>
                i.generalItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }),
                )[0],
            ).length,
        );
      } catch (err) {
        alert(err.message);
      }
    };
    getPurchaseLists();

    setShowMed(true);
    setShowPro(false);
    setShowProAcc(false);
    setShowGen(false);
    getBranches();

    // getMedUnitLists()
    // getProUnitLists()
  }, []);

  const proSearch = (val) => {
    console.log(val, "val");
    if (val) {
      setProHOItemList(
        proHOItemList.filter((el) =>
          el.procedureItemName.toLowerCase().includes(val.toLowerCase()),
        ),
      );
      setShowProSearch(true);
      setHidePro(false);
    } else {
      setShowProSearch(false);
      setHidePro(true);
    }
  };
  const medSearch = (val) => {
    if (val) {
      setMedHOItemList(
        medHOItemList.filter((el) =>
          el.medicineItemName.toLowerCase().includes(val.toLowerCase()),
        ),
      );

      setShowOrigin(true);
      setShowMed(false);

      setShowMedSearch(true);
    } else {
      setShowOrigin(true);

      setShowMedSearch(false);
      setShowMed(true);
    }
  };

  const proAccSearch = (val) => {
    if (val) {
      setAccHOItemList(
        accHOItemList.filter((el) =>
          el.code.toLowerCase().includes(val.toLowerCase()),
        ),
      );
      setShowProAccSearch(true);
      setHideProAcc(false);
    } else {
      setShowProAccSearch(false);
      setHideProAcc(true);
    }
  };

  const handleProBranch = (event) => {
    console.log(event, "branch id");
    setBranchID(event);
    if (event == "HO") {
      window.location.reload();
    } else {
      const getRelatedBranch = async () => {
        try {
          const res = await api.get("stocks/reorder", {
            params: { relatedBranch: event },
          });

          // setAccItemList(res.data.data.AccessoryItems)

          // setMedItemList(res.data.data.MedicineItems)

          // setProItemList(res.data.data.ProcedureItems)

          setAccBranchItemList(
            res.data.data.AccessoryItems.filter(
              (el) => el.relatedBranch == event,
            ),
          );
          setAccBranchCount(res.data.data.AccessoryItems.length);

          setMedBranchItemList(
            res.data.data.MedicineItems.filter(
              (el) => el.relatedBranch == event,
            ),
          );
          setMedBranchCount(res.data.data.MedicineItems.length);

          setProBranchItemList(
            res.data.data.ProcedureItems.filter(
              (el) => el.relatedBranch == event,
            ),
          );
          setProBranchCount(res.data.data.ProcedureItems.length);

          // setRelatedProBranch(
          //   res.data.data.filter(el => el.relatedBranch._id === event)
          // )
          console.log(res.data.data, "list");
        } catch (err) {
          alert(err.message);
        }
      };
      getRelatedBranch();

      setShowBranch(true);
      // setShowMedicine(false)
      setShowProUnit(false);
      setShowProAss(false);
      setHidePro(false);
      setShowOrigin(false);
    }
  };
  //General Branch
  const GenSearch = (val) => {
    if (val) {
      setGenHOItemList(
        genHOItemList.filter((el) =>
          el.generalItemName.toLowerCase().includes(val.toLowerCase()),
        ),
      );
      setShowGenSearch(true);
      setHideGen(false);
    } else {
      setShowProAccSearch(false);
      setHideProAcc(true);
    }
  };

  const handleGenBranch = (event) => {
    console.log(event, "branch id");
    setBranchID(event);
    if (event == "HO") {
      window.location.reload();
    } else {
      const getRelatedBranch = async () => {
        try {
          const res = await api.get("stocks/reorder", {
            params: { relatedBranch: event },
          });

          // setAccItemList(res.data.data.AccessoryItems)

          // setMedItemList(res.data.data.MedicineItems)

          // setProItemList(res.data.data.ProcedureItems)
          setGenBranchItemList(
            res.data.data.GeneralItems.filter(
              (el) => el.relatedBranch == event,
            ),
          );
          setGenBranchCount(res.data.data.GeneralItems.length);

          setAccBranchItemList(
            res.data.data.AccessoryItems.filter(
              (el) => el.relatedBranch == event,
            ),
          );
          setAccBranchCount(res.data.data.AccessoryItems.length);

          setMedBranchItemList(
            res.data.data.MedicineItems.filter(
              (el) => el.relatedBranch == event,
            ),
          );
          setMedBranchCount(res.data.data.MedicineItems.length);

          setProBranchItemList(
            res.data.data.ProcedureItems.filter(
              (el) => el.relatedBranch == event,
            ),
          );
          setProBranchCount(res.data.data.ProcedureItems.length);

          // setRelatedProBranch(
          //   res.data.data.filter(el => el.relatedBranch._id === event)
          // )
          console.log(res.data.data, "list");
        } catch (err) {
          alert(err.message);
        }
      };
      getRelatedBranch();

      setShowBranch(true);
      // setShowMedicine(false)
      setShowProUnit(false);
      setShowProAss(false);
      setHidePro(false);
      setShowOrigin(false);
    }
  };
  return (
    <>

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item active">
                      Expired Date List
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="content">
            <div className="container-fluid">
              <div className="row d-flex justify-content-between ">
                <div className="col-md-6">
                  {/* <h4>Medicine Item List</h4> */}
                </div>
                <div className="offset-1 col-md-4 ml-5">
                  <div
                    className="input-group row ml-5"
                    style={{ marginBottom: "20px" }}
                  >
                    {/* <div className="col-md-6 mt-1">
                      <button
                        type="button"
                        className="btn  btn-primary ml-4"
                        style={{ borderRadius: "7px" }}
                        onClick={showDialog}>
                        Add Item
                      </button>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="row">
                        <div className="col-md-7">
                          <div className="row">
                            <div className="col-md-3">
                              <Button
                                style={ButtonStyle}
                                onClick={() => handleMedUnitChange(branchID)}
                              >
                                Medicine Items &nbsp;{" "}
                                {branchID ? (
                                  <Badge color="error">{medBranchCount}+</Badge>
                                ) : (
                                  <Badge color="error" className="">
                                    {medHOCount}+
                                  </Badge>
                                )}
                              </Button>
                            </div>
                            <div className="col-md-3">
                              <Button
                                style={ButtonStyle}
                                onClick={() => handleProUnitChange(branchID)}
                              >
                                Procedure Items &nbsp;{" "}
                                {branchID ? (
                                  <Badge color="error">{proBranchCount}+</Badge>
                                ) : (
                                  <Badge color="error">{proHOCount}+</Badge>
                                )}
                              </Button>
                            </div>
                            <div className="col-md-3">
                              <Button
                                style={ButtonStyle}
                                onClick={() => handleProAssUnitChange(branchID)}
                              >
                                Procedure Accessories &nbsp;{" "}
                                {branchID ? (
                                  <Badge color="error">{accBranchCount}+</Badge>
                                ) : (
                                  <Badge color="error">{accHOCount}+</Badge>
                                )}
                              </Button>
                            </div>
                            <div className="col-md-3">
                              <Button
                                style={ButtonStyle}
                                onClick={() => handleGenUnitChange(branchID)}
                              >
                                General Items &nbsp;{" "}
                                {branchID ? (
                                  <Badge color="error">{genBranchCount}+</Badge>
                                ) : (
                                  <Badge color="error">{genHOCount}+</Badge>
                                )}
                              </Button>
                            </div>
                          </div>
                        </div>
                        {/* <div className='offset-1 col-md-3 mt-1'>
                          <div className='form-group'>
                            <select
                              name='currency'
                              id=''
                              className='form-control mt-1'
                              onchange='convert(this.value)'
                              // placeholder='Filter By Branches'
                              onChange={(e) => handleProBranch(e.target.value)}
                            >
                              <option hidden>Filter By Branches</option>
                              <option value='HO'>HO</option>

                              {branchesLists.map((option) => (
                                <option value={option._id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div> */}
                      </div>
                    </div>

                    <div className="card-body">
                      {/* Export data in Excel */}
                      {/* For Procedure Medicine Items */}
                      <ExcelExport data={proBranchItemList} ref={_export1}>
                        <ExcelExportColumn
                          field=""
                          title="No"
                          locked={true}
                          width={30}
                        />
                        <ExcelExportColumn
                          field="relatedProcedureItems.code"
                          title="Code"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={200}
                        />
                        <ExcelExportColumn
                          field="relatedProcedureItems.procedureItemName"
                          title="Procedure Item Name"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />
                        <ExcelExportColumn
                          field="relatedProcedureItems.currentQuantity"
                          title="Qty"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field="relatedProcedureItems.totalUnit"
                          title="Total Unit"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />

                        <ExcelExportColumn
                          field="relatedProcedureItems.reOrderQuantity"
                          title="Reorder Qty"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />
                        <ExcelExportColumn
                          field="relatedProcedureItems.unit"
                          title="Unit"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />

                        <ExcelExportColumn
                          field="actualStock"
                          title="Actual Stock"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />

                        <ExcelExportColumn
                          field="different"
                          title="Different"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />
                      </ExcelExport>
                      {/* End        */}

                      {/* For Medicine Items */}
                      <ExcelExport data={medHOItemList} ref={_export2}>
                        <ExcelExportColumn
                          field=""
                          title="No"
                          locked={true}
                          width={30}
                        />
                        <ExcelExportColumn
                          field="relatedMedicineItems.code"
                          title="Code"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={200}
                        />
                        <ExcelExportColumn
                          field="relatedMedicineItems.medicineItemName"
                          title="Medicine Item Name"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />
                        <ExcelExportColumn
                          field="relatedMedicineItems.currentQuantity"
                          title="Qty"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field="relatedMedicineItems.totalUnit"
                          title="Total Unit"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />

                        <ExcelExportColumn
                          field="relatedMedicineItems.reOrderQuantity"
                          title="Reorder Qty"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />

                        <ExcelExportColumn
                          field="relatedMedicineItems.unit"
                          title="Unit"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />

                        <ExcelExportColumn
                          field="actualStock"
                          title="Actual Stock"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />

                        <ExcelExportColumn
                          field="different"
                          title="Different"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />
                      </ExcelExport>
                      {/* End     */}

                      {/* For Procedure Accessory FilterItems */}

                      <ExcelExport data={genBranchItemList} ref={_export4}>
                        <ExcelExportColumn
                          field=""
                          title="No"
                          locked={true}
                          width={30}
                        />
                        <ExcelExportColumn
                          field="relatedGeneralItems.code"
                          title="Code"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={200}
                        />
                        <ExcelExportColumn
                          field="relatedGeneralItems.generalItemName"
                          title="General Item Name"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />
                        <ExcelExportColumn
                          field="relatedGeneralItems.currentQuantity"
                          title="Qty"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field="relatedGeneralItems.totalUnit"
                          title="Total Unit"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />

                        <ExcelExportColumn
                          field="relatedGeneralItems.reOrderQuantity"
                          title="Reorder Qty"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />

                        <ExcelExportColumn
                          field="relatedGeneralItems.unit"
                          title="Unit"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />

                        <ExcelExportColumn
                          field="actualStock"
                          title="Actual Stock"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />

                        <ExcelExportColumn
                          field="different"
                          title="Different"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />
                      </ExcelExport>

                      {/* End */}

                      {/* Export Data in Excel end */}
                      <div className="row">
                        <div className="col-md-12">
                          <div className="table-responsive">
                            <table className="table table-hover">
                              {showBranch && (
                                <div>
                                  <div className="row justify-content-between mb-3">
                                    <div className="col-md-3">
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-dark"
                                        onClick={excelExport2}
                                      >
                                        <FaFileExport />
                                        &nbsp; Export
                                      </button>
                                      &nbsp;
                                    </div>
                                    <div className="col-md-3 mr-2">
                                      <div className="row">
                                        <div className="col-md-8">
                                          <input
                                            type="search"
                                            className="form-control rounded "
                                            style={{ borderRadius: "17px" }}
                                            // onChange={e =>
                                            //   medSearch(e.target.value)
                                            // }
                                            id="search_code"
                                            placeholder="Search Items"
                                          />
                                        </div>
                                        {/* <div className='col-md-4 mt-2'>
                                          <button
                                            type='button'
                                            className='btn btn-sm btn-dark'
                                            onClick={medSearch}
                                          >
                                            Search
                                          </button>
                                        </div> */}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="table-responsive">
                                    <table className="table table-hover">
                                      <thead>
                                        <tr>
                                          <th style={{ fontWeight: "400px" }}>
                                            #
                                          </th>
                                          <th style={{ fontWeight: "400px" }}>
                                            Code
                                          </th>
                                          <th style={{ fontWeight: "400px" }}>
                                            Name
                                          </th>
                                          <th style={{ fontWeight: "400px" }}>
                                            Qty
                                          </th>

                                          <th style={{ fontWeight: "400px" }}>
                                            Total Unit
                                          </th>

                                          <th style={{ fontWeight: "400px" }}>
                                            Reorder Qty
                                          </th>
                                          <th style={{ fontWeight: "400px" }}>
                                            Unit
                                          </th>
                                          <th>Select</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {console.log(
                                          relatedProBranch,
                                          "relatedProBranch",
                                        )}
                                        {medBranchItemList.map((proUnit, i) => (
                                          <tr>
                                            <td>{++i}</td>
                                            <td>
                                              {proUnit.relatedProcedureItems
                                                ? proUnit.relatedProcedureItems
                                                    .code
                                                : proUnit.relatedMedicineItems
                                                  ? proUnit.relatedMedicineItems
                                                      .code
                                                  : proUnit.relatedAccessoryItems
                                                    ? proUnit
                                                        .relatedAccessoryItems
                                                        .code
                                                    : ""}
                                            </td>
                                            <td>
                                              {proUnit.relatedProcedureItems
                                                ? proUnit.relatedProcedureItems
                                                    .procedureItemName
                                                : proUnit.relatedMedicineItems
                                                  ? proUnit.relatedMedicineItems
                                                      .medicineItemName
                                                  : proUnit.relatedAccessoryItems
                                                    ? proUnit
                                                        .relatedAccessoryItems
                                                        .accessoryItemName
                                                    : ""}
                                            </td>
                                            <td>{proUnit.currentQty}</td>

                                            <td>
                                              {proUnit.relatedProcedureItems
                                                ? proUnit.relatedProcedureItems
                                                    .totalUnit
                                                : ""}
                                            </td>

                                            <td>{proUnit.reOrderQuantity}</td>
                                            <td>PCS</td>
                                            <td>
                                              <input type="checkbox" />
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              )}
                              {showProBranch && (
                                <div>
                                  <div className="row justify-content-between mb-3">
                                    <div className="col-md-3">
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-dark"
                                        onClick={excelExport1}
                                      >
                                        <FaFileExport />
                                        &nbsp; Export
                                      </button>
                                      &nbsp;
                                    </div>
                                    <div className="col-md-3 mr-2">
                                      <div className="row">
                                        <div className="col-md-8">
                                          <input
                                            type="search"
                                            className="form-control rounded "
                                            style={{ borderRadius: "17px" }}
                                            onChange={(e) =>
                                              setProName(e.target.value)
                                            }
                                            id="search_code"
                                            placeholder="Search Items"
                                          />
                                        </div>
                                        <div className="col-md-4 mt-2">
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-dark"
                                            // onClick={search}
                                          >
                                            Search
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="table-responsive">
                                    <table className="table table-hover">
                                      <thead>
                                        <tr>
                                          <th style={{ fontWeight: "400px" }}>
                                            #
                                          </th>
                                          <th style={{ fontWeight: "400px" }}>
                                            Code
                                          </th>
                                          <th style={{ fontWeight: "400px" }}>
                                            Name
                                          </th>
                                          <th style={{ fontWeight: "400px" }}>
                                            Qty
                                          </th>

                                          <th style={{ fontWeight: "400px" }}>
                                            Total Unit
                                          </th>

                                          <th style={{ fontWeight: "400px" }}>
                                            Reorder Qty
                                          </th>
                                          <th style={{ fontWeight: "400px" }}>
                                            Unit
                                          </th>
                                          <th>Select</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {proBranchItemList.map((proUnit, i) => (
                                          <tr>
                                            <td>{++i}</td>
                                            <td>
                                              {proUnit.relatedProcedureItems
                                                ? proUnit.relatedProcedureItems
                                                    .code
                                                : proUnit.relatedMedicineItems
                                                  ? proUnit.relatedMedicineItems
                                                      .code
                                                  : proUnit.relatedAccessoryItems
                                                    ? proUnit
                                                        .relatedAccessoryItems
                                                        .code
                                                    : ""}
                                            </td>
                                            <td>
                                              {proUnit.relatedProcedureItems
                                                ? proUnit.relatedProcedureItems
                                                    .procedureItemName
                                                : proUnit.relatedMedicineItems
                                                  ? proUnit.relatedMedicineItems
                                                      .medicineItemName
                                                  : proUnit.relatedAccessoryItems
                                                    ? proUnit
                                                        .relatedAccessoryItems
                                                        .accessoryItemName
                                                    : ""}
                                            </td>
                                            <td>{proUnit.currentQty}</td>

                                            <td>
                                              {proUnit.relatedProcedureItems
                                                ? proUnit.relatedProcedureItems
                                                    .totalUnit
                                                : ""}
                                            </td>

                                            <td>
                                              {proUnit.relatedProcedureItems
                                                ? proUnit.relatedProcedureItems
                                                    .reOrderQuantity
                                                : ""}
                                            </td>
                                            <td>PCS</td>
                                            <td>
                                              <input type="checkbox" />
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              )}
                              {showProAccBranch && (
                                <div>
                                  <div className="row justify-content-between mb-3">
                                    <div className="col-md-3">
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-dark"
                                        onClick={excelExport3}
                                      >
                                        <FaFileExport />
                                        &nbsp; Export
                                      </button>
                                      &nbsp;
                                    </div>
                                    <div className="col-md-3 mr-2">
                                      <div className="row">
                                        <div className="col-md-8">
                                          <input
                                            type="search"
                                            className="form-control rounded "
                                            style={{ borderRadius: "17px" }}
                                            onChange={(e) =>
                                              proAccSearch(e.target.value)
                                            }
                                            id="search_code"
                                            placeholder="Search Items"
                                          />
                                        </div>
                                        {/* <div className='col-md-4 mt-2'>
                                          <button
                                            type='button'
                                            className='btn btn-sm btn-dark'
                                            onClick={proAccSearch}
                                          >
                                            Search
                                          </button>
                                        </div> */}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="table-responsive">
                                    <table className="table table-hover">
                                      <thead>
                                        <tr>
                                          <th style={{ fontWeight: "400px" }}>
                                            #
                                          </th>
                                          <th style={{ fontWeight: "400px" }}>
                                            Code
                                          </th>
                                          <th style={{ fontWeight: "400px" }}>
                                            Name
                                          </th>
                                          <th style={{ fontWeight: "400px" }}>
                                            Qty
                                          </th>

                                          <th style={{ fontWeight: "400px" }}>
                                            Total Unit
                                          </th>

                                          <th style={{ fontWeight: "400px" }}>
                                            Reorder Qty
                                          </th>
                                          <th style={{ fontWeight: "400px" }}>
                                            Unit
                                          </th>
                                          <th>Select</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {console.log(
                                          relatedProBranch,
                                          "relatedProBranch",
                                        )}
                                        {accBranchItemList.map((proUnit, i) => (
                                          <tr>
                                            <td>{++i}</td>
                                            <td>
                                              {proUnit.relatedAccessoryItems
                                                ? proUnit.relatedAccessoryItems
                                                    .code
                                                : ""}
                                            </td>
                                            <td>
                                              {
                                                proUnit.relatedAccessoryItems
                                                  .accessoryItemName
                                              }
                                            </td>
                                            <td>{proUnit.currentQty}</td>

                                            <td>
                                              {proUnit.relatedAccessoryItems
                                                ? proUnit.relatedAccessoryItems
                                                    .totalUnit
                                                : ""}
                                            </td>

                                            <td>
                                              {proUnit.relatedAccessoryItems
                                                ? proUnit.relatedAccessoryItems
                                                    .reOrderQuantity
                                                : ""}
                                            </td>
                                            <td>PCS</td>
                                            <td>
                                              <input type="checkbox" />
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>

                                  <div className="table-responsive">
                                    <table className="table table-hover">
                                      <thead>
                                        <tr>
                                          <th style={{ fontWeight: "400px" }}>
                                            #
                                          </th>
                                          <th style={{ fontWeight: "400px" }}>
                                            Code
                                          </th>
                                          <th style={{ fontWeight: "400px" }}>
                                            Name
                                          </th>
                                          <th style={{ fontWeight: "400px" }}>
                                            Qty
                                          </th>

                                          <th style={{ fontWeight: "400px" }}>
                                            Total Unit
                                          </th>

                                          <th style={{ fontWeight: "400px" }}>
                                            Reorder Qty
                                          </th>
                                          <th style={{ fontWeight: "400px" }}>
                                            Unit
                                          </th>
                                          <th>Select</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {genBranchItemList.map((genUnit, i) => (
                                          <tr>
                                            <td>{++i}</td>
                                            <td>
                                              {genUnit.relatedGeneralItems
                                                ? genUnit.relatedGeneralItems
                                                    .code
                                                : ""}
                                            </td>
                                            <td>
                                              {
                                                genUnit.relatedGeneralItems
                                                  .generalItemName
                                              }
                                            </td>
                                            <td>{genUnit.currentQty}</td>

                                            <td>
                                              {genUnit.relatedGeneralItems
                                                ? genUnit.relatedGeneralItems
                                                    .totalUnit
                                                : ""}
                                            </td>

                                            <td>
                                              {genUnit.relatedGeneralItems
                                                ? genUnit.relatedGeneralItems
                                                    .reOrderQuantity
                                                : ""}
                                            </td>
                                            <td>PCS</td>
                                            <td>
                                              <input type="checkbox" />
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              )}
                              {showOrigin && (
                                <>
                                  {showMed && (
                                    <div>
                                      <div className="row justify-content-between mb-3">
                                        <div className="col-md-6">
                                          {/* <button
                                            type='button'
                                            className='btn btn-sm btn-dark'
                                            onClick={excelExport2}
                                          >
                                            <FaFileExport />
                                            &nbsp; Export
                                          </button> */}
                                          &nbsp;
                                        </div>
                                        <div className="col-md-3 mr-2">
                                          <div className="row">
                                            <div className="col-md-8">
                                              <input
                                                type="search"
                                                className="form-control rounded "
                                                style={{ borderRadius: "17px" }}
                                                onChange={(e) =>
                                                  medSearch(e.target.value)
                                                }
                                                id="search_code"
                                                placeholder="Search Items"
                                              />
                                            </div>
                                            {/* <div className='col-md-2 mt-2'>
                                              <button
                                                type='button'
                                                className='btn btn-sm btn-dark'
                                                // onClick={medSearch}
                                              >
                                                Search
                                              </button>
                                            </div> */}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="table-responsive">
                                        <table className="table table-hover">
                                          <thead>
                                            <tr>
                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                #
                                              </th>
                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                Code
                                              </th>
                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                Purchase Date
                                              </th>
                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                Reason
                                              </th>

                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                Remark
                                              </th>

                                              <th>Action</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {console.log(
                                              relatedProBranch,
                                              "relatedProBranch",
                                            )}
                                            {medHOItemList
                                              .sort(
                                                (a, b) =>
                                                  new Date(b.date) -
                                                  new Date(a.date),
                                              )
                                              .map((medUnit, i) => (
                                                <tr>
                                                  <td>{++i}</td>
                                                  <td>{medUnit.code}</td>
                                                  <td>
                                                    {
                                                      medUnit.purchaseDate?.split(
                                                        "T",
                                                      )[0]
                                                    }
                                                  </td>
                                                  <td>{medUnit?.reason}</td>

                                                  <td>{medUnit?.remark}</td>

                                                  <td>
                                                    <Link
                                                      to={
                                                        "/expDetail/" +
                                                        medUnit._id
                                                      }
                                                      className="btn btn-sm border-dark"
                                                    >
                                                      Detail
                                                    </Link>
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  )}
                                  {showMedSearch && (
                                    <div>
                                      <div className="row justify-content-between mb-3">
                                        <div className="col-md-6">
                                          {/* <button
                                            type='button'
                                            className='btn btn-sm btn-dark'
                                            onClick={excelExport2}
                                          >
                                            <FaFileExport />
                                            &nbsp; Export
                                          </button> */}
                                          &nbsp;
                                        </div>
                                        <div className="col-md-3 mr-2">
                                          <div className="row">
                                            <div className="col-md-8">
                                              <input
                                                type="search"
                                                className="form-control rounded "
                                                style={{ borderRadius: "17px" }}
                                                onChange={(e) =>
                                                  medSearch(e.target.value)
                                                }
                                                id="search_code"
                                                placeholder="Search Items"
                                              />
                                            </div>
                                            {/* <div className='col-md-2 mt-2'>
                                              <button
                                                type='button'
                                                className='btn btn-sm btn-dark'
                                                // onClick={medSearch}
                                              >
                                                Search
                                              </button>
                                            </div> */}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="table-responsive">
                                        <table className="table table-hover">
                                          <thead>
                                            <tr>
                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                #
                                              </th>
                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                Code
                                              </th>
                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                Name
                                              </th>
                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                Qty
                                              </th>

                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                Total Unit
                                              </th>

                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                Reorder Qty
                                              </th>
                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                Unit
                                              </th>
                                              <th>Desc</th>
                                              <th>Select</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {console.log(
                                              relatedProBranch,
                                              "relatedProBranch",
                                            )}
                                            {medHOItemList
                                              .sort(
                                                (a, b) =>
                                                  new Date(b.date) -
                                                  new Date(a.date),
                                              )
                                              .map((medUnit, i) => (
                                                <tr>
                                                  <td>{++i}</td>
                                                  <td>{medUnit.code}</td>
                                                  <td>
                                                    {medUnit.medicineItemName
                                                      ? medUnit.medicineItemName
                                                      : ""}
                                                  </td>
                                                  <td>
                                                    {medUnit.currentQuantity}
                                                  </td>

                                                  <td>{medUnit.totalUnit}</td>

                                                  <td>
                                                    {medUnit.reOrderQuantity}
                                                  </td>
                                                  <td>PCS</td>
                                                  <td>{medUnit.description}</td>
                                                  <td>
                                                    <Link
                                                      to={
                                                        "/expDetail/" +
                                                        medUnit._id
                                                      }
                                                      className="btn btn-sm border-dark"
                                                    >
                                                      Detail
                                                    </Link>
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  )}

                                  {showProAcc && (
                                    <div>
                                      <div className="row justify-content-between mb-3">
                                        <div className="col-md-3">
                                          {/* <button
                                            type='button'
                                            className='btn btn-sm btn-dark'
                                            onClick={excelExport2}
                                          >
                                            <FaFileExport />
                                            &nbsp; Export
                                          </button> */}
                                          &nbsp;
                                        </div>
                                        <div className="col-md-3 mr-2">
                                          <div className="row">
                                            <div className="col-md-8">
                                              <input
                                                type="search"
                                                className="form-control rounded "
                                                style={{ borderRadius: "17px" }}
                                                onChange={(e) =>
                                                  proAccSearch(e.target.value)
                                                }
                                                id="search_code"
                                                placeholder="Search Items"
                                              />
                                            </div>
                                            {/* z */}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="table-responsive">
                                        <table className="table table-hover">
                                          <thead>
                                            <tr>
                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                #
                                              </th>
                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                Code
                                              </th>
                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                Purchase Date
                                              </th>
                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                Reason
                                              </th>

                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                Remark
                                              </th>

                                              <th>Action</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {accHOItemList
                                              .sort(
                                                (a, b) =>
                                                  new Date(b.date) -
                                                  new Date(a.date),
                                              )
                                              .map((accUnit, i) => (
                                                <tr>
                                                  <td>{++i}</td>
                                                  <td>{accUnit.code}</td>
                                                  <td>
                                                    {
                                                      accUnit.purchaseDate?.split(
                                                        "T",
                                                      )[0]
                                                    }
                                                  </td>
                                                  <td>{accUnit?.reason}</td>

                                                  <td>{accUnit?.remark}</td>

                                                  <td>
                                                    <Link
                                                      to={
                                                        "/expDetail/" +
                                                        accUnit._id
                                                      }
                                                      className="btn btn-sm border-dark"
                                                    >
                                                      Detail
                                                    </Link>
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  )}
                                  {showGen && (
                                    <div>
                                      <div className="row justify-content-between mb-3">
                                        <div className="col-md-3">
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-dark"
                                            onClick={excelExport4}
                                          >
                                            <FaFileExport />
                                            &nbsp; Export
                                          </button>
                                          &nbsp;
                                        </div>
                                        <div className="col-md-3 mr-2">
                                          <div className="row">
                                            <div className="col-md-8">
                                              <input
                                                type="search"
                                                className="form-control rounded "
                                                style={{ borderRadius: "17px" }}
                                                onChange={(e) =>
                                                  GenSearch(e.target.value)
                                                }
                                                id="search_code"
                                                placeholder="Search Items"
                                              />
                                            </div>
                                            {/* z */}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="table-responsive">
                                        <table className="table table-hover">
                                          <thead>
                                            <tr>
                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                #
                                              </th>
                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                Code
                                              </th>
                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                Name
                                              </th>
                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                Qty
                                              </th>

                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                Total Unit
                                              </th>

                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                Reorder Qty
                                              </th>
                                              <th
                                                style={{ fontWeight: "400px" }}
                                              >
                                                Unit
                                              </th>
                                              <th>Select</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {console.log(
                                              relatedProBranch,
                                              "relatedProBranch",
                                            )}
                                            {genHOItemList.map((genUnit, i) => (
                                              <tr>
                                                <td>{++i}</td>
                                                <td>{genUnit.code}</td>
                                                <td>
                                                  {genUnit.generalItemName
                                                    ? genUnit.generalItemName
                                                    : ""}
                                                </td>
                                                <td>
                                                  {genUnit.currentQuantity}
                                                </td>

                                                <td>{genUnit.totalUnit}</td>

                                                <td>
                                                  {genUnit.reOrderQuantity}
                                                </td>
                                                <td>
                                                  {status === "Checked"
                                                    ? "Checked"
                                                    : "UnCheck"}
                                                </td>
                                                <td>{genUnit.description}</td>
                                                <td>
                                                  <button
                                                    type="checkbox"
                                                    className="btn btn-sm btn-primary"
                                                    // onClick={(e) =>
                                                    //   handleGenCheck(i)
                                                    // }
                                                  >
                                                    OK
                                                  </button>
                                                </td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  )}
                                </>
                              )}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <StockCountModal
                open={open}
                close={() => setOpen(false)}
                branchesLists={branchesLists}
                setOpen={setOpen}
              /> */}
            </div>
          </section>
        </div>

    </>
  );
}
